module.exports = {
  "country": "IE",
  "artist": "Eimear Quinn",
  "song": "The Voice",
  "year": "1996",
  "place": "1",
  "spotify": "6SA7BxY6zh5SaxUBp3tCtb"
};